import SvgIcon from "@mui/material/SvgIcon";

const LogoIcon = ({ className = "" }: any) => (
    <svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_8416_26)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.6301 3.11914C8.72295 3.11914 0.685059 11.157 0.685059 21.0642C0.685059 30.9714 8.72295 39.0093 18.6301 39.0093C28.5373 39.0093 36.5752 30.9714 36.5752 21.0642C36.5752 11.157 28.5373 3.11914 18.6301 3.11914ZM18.6301 27.0459C15.3277 27.0459 12.6484 24.3666 12.6484 21.0642C12.6484 17.7618 15.3277 15.0825 18.6301 15.0825C21.9325 15.0825 24.6118 17.7618 24.6118 21.0642C24.6118 24.3666 21.9325 27.0459 18.6301 27.0459Z"
                fill="white"
            />
            <path
                d="M18.6305 2.43359C8.3619 2.43359 0 10.7955 0 21.0641C0 31.3326 8.3619 39.6945 18.6305 39.6945C28.899 39.6945 37.2609 31.3326 37.2609 21.0641C37.2609 10.7955 28.899 2.43359 18.6305 2.43359ZM18.6305 38.3237C9.10961 38.3237 1.3708 30.5849 1.3708 21.0641C1.3708 11.5432 9.10961 3.8044 18.6305 3.8044C28.1513 3.8044 35.8901 11.5432 35.8901 21.0641C35.8901 30.5849 28.1513 38.3237 18.6305 38.3237Z"
                fill="#013FBF"
            />
            <path
                d="M18.631 14.3965C14.9547 14.3965 11.9639 17.3873 11.9639 21.0636C11.9639 24.7398 14.9547 27.7307 18.631 27.7307C22.3072 27.7307 25.298 24.7398 25.298 21.0636C25.298 17.3873 22.3072 14.3965 18.631 14.3965ZM18.631 26.3599C15.7149 26.3599 13.3347 23.9796 13.3347 21.0636C13.3347 18.1475 15.7149 15.7673 18.631 15.7673C21.547 15.7673 23.9272 18.1475 23.9272 21.0636C23.9272 23.9796 21.547 26.3599 18.631 26.3599Z"
                fill="#013FBF"
            />
            <path
                d="M21.7832 38.2994L15.8015 35.3085C15.6893 35.2462 15.5522 35.2587 15.4401 35.321C15.3279 35.3958 15.2656 35.5079 15.2656 35.645V41.6267C15.2656 41.7513 15.3279 41.8759 15.4401 41.9507C15.5024 41.9881 15.5647 42.0006 15.6395 42.0006C15.7018 42.0006 15.7516 41.9881 15.8015 41.9632L21.7832 38.9723C21.9078 38.91 21.995 38.7854 21.995 38.6359C21.995 38.4863 21.9203 38.3617 21.7832 38.2994Z"
                fill="#013FBF"
            />
            <path
                d="M21.8206 0.0534271C21.7084 -0.00888213 21.5713 -0.021344 21.4592 0.0409652L15.4775 3.03181C15.3529 3.09412 15.2656 3.21874 15.2656 3.36828C15.2656 3.51782 15.3404 3.64244 15.4775 3.70475L21.4592 6.69559C21.509 6.72051 21.5713 6.73298 21.6212 6.73298C21.6835 6.73298 21.7582 6.70805 21.8206 6.67067C21.9327 6.5959 21.995 6.48374 21.995 6.34666V0.377435C21.995 0.240355 21.9327 0.128198 21.8206 0.0534271Z"
                fill="#013FBF"
            />
        </g>
        <defs>
            <clipPath id="clip0_8416_26">
                <rect width="37.2609" height="42.0003" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default LogoIcon;
